<template>
  <div class="text-center small-pie">
    <apexchart height="80" type="donut" :options="messagesResolveReasonOptions" :series="messagesResolveReasonSeries"></apexchart>
  </div>
</template>

<script>
import { useReasonForResolvingStore } from '@/stores/reasonForResolving'

export default {
  name: 'agentReasonsForResolving',
  props: ['dataset'],
  setup() {
    let reasonForResolvingStore = useReasonForResolvingStore();
    return { reasonForResolvingStore };
  },
  computed: {
    datasetWithLabels() {
      let dataset = [];
      this.dataset.forEach(row => {
        let reason = this.reasonForResolvingStore.getById(row.attributes['reason-id']);
        if (reason) {
          dataset.push({'label': reason.attributes.reason, 'count': row['attributes']['count']});
        }
      });
      return dataset;
    },
    messagesResolveReasonOptions() {
      let labels = [];
      if (this.datasetWithLabels.length > 0) {
        this.datasetWithLabels.forEach(row => {
          labels.push(row.label);
        });
      }
      return {
        labels: labels,
        colors: ['#6366f1', '#4c1d95', '#3b82f6', '#581c87', '#0ea5e9', '#701a75', '#06b6d4',
                 '#312e81', '#8b5cf6', '#1e3a8a', '#a855f7', '#0c4a6e', '#d946ef', '#164e63'],
        sparkline: {
          enabled: true
        },
        stroke: {
          width: 1
        },
        tooltip: {
          fixed: {
            enabled: false
          },
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: false,
              },
            },
          },
        },
        legend: {
          show: false,
        },
        dataLabels: {
          enabled: false
        },
        responsive: [{
          options: {
            legend: {
              show: false,
            },
          },
        }],
      };
    },
    messagesResolveReasonSeries() {
      let dataset = [];
      if (this.datasetWithLabels.length > 0) {
        this.datasetWithLabels.forEach(row => {
          dataset.push(row['count']);
        });
      }
      return dataset;
    },
  },
}
</script>
